import React, {Component} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
  InputGroup,
  InputGroupAddon,
  Input,
} from 'reactstrap';
import {application} from "../constants/configs";
import {Field, Form as FinalForm} from 'react-final-form';
import TextField from '../components/TextField';
import {Colxx, Separator} from '../components/common/CustomBootstrap';
import {NotificationManager} from '../components/common/react-notifications';
import LoaderButton from '../components/LoaderButton';
import {difference, selectStyles, sleep} from '../helpers/Utils';
import SecurityVerificationForm from './SecurityVerificationForm';
import ModalManager from '../components/modal/ModalManager';
import FieldError from '../components/FieldError';
import Skeleton from 'react-loading-skeleton';
import {withTranslation} from 'react-i18next';
import {forEach, isEmpty} from 'lodash';
import Rbac from '../components/Rbac';
import Switch from 'react-switch';
import Select from 'react-select';
import Api from '../services/Api';

class KycMetaInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      syncing: false,
      info: {...props.kycInfo},
      selectedLevel: {
        label: String(props.kycInfo.level),
        value: props.kycInfo.level
      },
      automatedLevelEvaluation: props.automatedLevelEvaluation,
      levelOptions: props.levels.map(level => ({
        label: String(level), value: level
      })),
    };

    this.statusOptions = [
      {value: 'Submitted', label: props.t('Submitted')},
      {value: 'Not Submitted', label: props.t('Not Submitted')},
      {value: 'Waiting for Modification', label: props.t('Waiting for Modification')},
      {value: 'Verified', label: props.t('Verified')},
      {value: 'Rejected', label: props.t('Rejected')},
    ];
  }

  componentDidUpdate(prevProps) {
    if (prevProps.levels !== this.props.levels) {
      this.setState({
        levelOptions: this.props.levels.map(level => ({
          label: String(level), value: level
        })),
      });
    }
    if (prevProps.kycInfo.level !== this.props.kycInfo.level) {
      this.setState({
        selectedLevel: {
          label: String(this.props.kycInfo.level),
          value: this.props.kycInfo.level
        },
      });
    }
  }

  updateInfo = async values => {
    try {
      const {t, userId} = this.props;
      const formData = new FormData();
      formData.append('userId', userId);
      const diff = difference(values, this.state.info);
      if (!isEmpty(diff)) {
        forEach(diff, (value, key) => {
          formData.append(key, value);
        });
        const response = await Api.invoke('PATCH', '/admin-ui/user-kyc-info', formData);
        this.setState({
          info: {
            ...this.state.info,
            ...response.data,
          },
        });
        NotificationManager.success(t('Info updated successfully'), t('Message'));
      } else {
        NotificationManager.warning(t('Info has not be changed'), t('Message'));
      }
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateNationalCode = async values => {
    try {
      const {info} = this.state;
      const {t, userId} = this.props;
      const {data} = await Api.invoke('PATCH', '/admin-ui/user-kyc-info', {
        ...values,
        userId,
      });
      this.setState({
        info: {
          ...info,
          ...values,
          shahkarVerified: data.shahkarVerified,
        },
      });
      NotificationManager.success(t('User national code updated successfully'), t('Message'));
      // if (info.shahkarVerified) {
      //   this.showNationalCodeChangedModal();
      // }
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  onSubmitPhoneNumber = async values => {
    const {t} = this.props;
    const {info} = this.state;
    const {data} = await Api.invoke('PUT', '/admin-ui/user-phone-number', values);
    this.setState({
      info: {
        ...info,
        ...values,
        shahkarVerified: data.shahkarVerified,
      },
    });
    NotificationManager.success(t('User mobile number updated successfully'), t('Message'));
  };

  updatePhoneNumber = async values => {
    const {t, userId} = this.props;
    const payload = {
      ...values,
      userId,
    };
    const action = 'put-admin-ui-user-phone-number';
    try {
      const {data} = await Api.invoke('POST', '/admin-ui/access-token', {
        payload: JSON.stringify(payload),
        action,
      });
      ModalManager.close({isOpen: false});
      await sleep(500);
      ModalManager.open({
        isOpen: true,
        title: t('Security Verification'),
        body: this.renderPhoneNumberSecurityVerificationForm(action, payload, data),
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  renderPhoneNumberSecurityVerificationForm = (action, payload, accessData) => {
    return (
      <SecurityVerificationForm
        action={action}
        accessData={accessData}
        onSubmit={async values => {
          await this.onSubmitPhoneNumber({
            ...payload,
            ...values,
          });
        }}
      />
    );
  };

  onChangeAutomatedLevelEvaluationStatus = confirmed => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Notice'),
      body: confirmed ?
        t('If approved, the user level is automatically evaluated based on the items submitted and the level may change. Are you sure?') :
        t('If approved, the user level will not be automatically evaluated based on the items submitted. Are you sure?'),
      buttons: [
        {
          color: 'primary',
          onClick: () => {
            this.changeAutomatedLevelEvaluation(confirmed);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  changeAutomatedLevelEvaluation = async confirmed => {
    const {t, userId} = this.props;
    this.setState({
      automatedLevelEvaluation: confirmed,
    });
    try {
      const {data} = await Api.invoke('PATCH', '/admin-ui/user-settings', {
        userId,
        automatedLevelEvaluation: confirmed,
      });
      const updatedInfo = {
        ...data,
        ...(data.kycLevel ? {
          level: data.kycLevel,
        } : null),
      };
      this.setState({
        info: {
          ...this.state.info,
          ...updatedInfo,
        },
        ...(data.kycLevel ? {
          selectedLevel: {
            label: String(data.kycLevel),
            value: data.kycLevel
          },
        } : null),
      });
      NotificationManager.success(t('Automated level evaluation status updated successfully'), t('Message'));
    } catch (e) {
      this.setState({
        automatedLevelEvaluation: !confirmed,
      });
      console.log('error: ', e);
    }
  };

  onChangePhoneNumberStatus = async confirmed => {
    const {info} = this.state;
    const {t, userId} = this.props;
    this.setState({
      info: {
        ...info,
        phoneNumberVerified: confirmed,
      },
    });
    try {
      const {data} = await Api.invoke('PATCH', '/admin-ui/user-kyc-info', {
        userId,
        phoneNumberVerified: confirmed,
      });
      this.setState({
        info: {
          ...info,
          phoneNumberVerified: confirmed,
          ...(typeof data.shahkarVerified === 'boolean' ? {
            shahkarVerified: data.shahkarVerified,
          } : null)
        },
      });
      NotificationManager.success(t('Mobile number status updated successfully'), t('Message'));
    } catch (e) {
      this.setState({
        info: {
          ...info,
          phoneNumberVerified: !confirmed,
        },
      });
      console.log('error: ', e);
    }
  };

  showNationalCodeChangedModal = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Notice'),
      body: t('Due to the change of user national code, you have to re-inquire about matching the national code and mobile number.'),
      buttons: [
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('I realized'),
        },
      ],
    });
  }

  showPhoneNumberChangedModal = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Notice'),
      body: t('Due to the change of user mobile number, you have to re-inquire about matching the national code and mobile number.'),
      buttons: [
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('I realized'),
        },
      ],
    });
  };

  onChangeLevel = level => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Notice'),
      body: t('If the identity level changes, the user identity level will not be automatically evaluated based on the items sent. Are you sure?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            this.changeLevel(level);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  changeLevel = async level => {
    const {automatedLevelEvaluation, levelOptions} = this.state;
    this.setState({
      selectedLevel: level,
      automatedLevelEvaluation: false,
    });
    const {t, userId, fetchProfile} = this.props;
    try {
      await Api.invoke('PUT', '/admin-ui/user-kyc-level', {
        level: level.value,
        userId,
      });
      this.setState({
        info: {
          ...this.state.info,
          level: level.value,
        },
      });
      fetchProfile();
      NotificationManager.success(t('Level updated successfully'), t('Message'));
    } catch (e) {
      this.setState({
        selectedLevel: levelOptions.find(item => item.value === this.state.info.level),
        automatedLevelEvaluation,
      });
      console.log('error: ', e);
    }
  };

  onChangeStatus = async status => {
    const {info} = this.state;
    this.setState({
      selectedStatus: status,
    });
    try {
      const {t, userId} = this.props;
      await Api.invoke('PUT', '/admin-ui/user-kyc-status', {
        status: status.value,
        userId,
      });
      this.setState({
        info: {
          ...info,
          verificationStatus: status.value,
        },
      });
      NotificationManager.success(t('Kyc status updated successfully'), t('Message'));
    } catch (e) {
      this.setState({
        selectedStatus: this.statusOptions.find(item => item.value === info.verificationStatus),
      });
      console.log('error: ', e);
    }
  };

  zarinpalSync = async () => {
    const {t, userId, fetchProfile} = this.props;
    this.setState({
      syncing: true,
    });
    try {
      await Api.invoke('POST', '/v2/admin-ui/zarinpal-sync', {
        userId,
      });
      fetchProfile();
      NotificationManager.success(t('User account synced with zarinpal successfully'), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        syncing: false,
      });
    }
  };

  getTextFields = t => [
    {
      name: 'legalFirstName',
      i18n: t('Legal First Name'),
      type: 'text',
      value: this.state.info.legalFirstName,
      disabled: !Rbac.hasPermission('update_user-kyc'),
    },
    {
      name: 'legalLastName',
      i18n: t('Legal Last Name'),
      type: 'text',
      value: this.state.info.legalLastName,
      disabled: !Rbac.hasPermission('update_user-kyc'),
    },
  ];

  render() {
    const {t, zarinpalId} = this.props;
    const {info, selectedLevel, automatedLevelEvaluation, levelOptions, syncing} = this.state;
    let textFields;
    if (info) {
      textFields = this.getTextFields(t);
    }
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary">
                {t('Identity Authentication Meta Info')}
              </CardTitle>
              {application.platformName === 'zarindax' &&
                <div>
                  <Row className="mx-0 align-items-center my-5">
                    <div className="font-weight-semibold mr-3" style={{fontSize: 16}}>
                      {!!zarinpalId ?
                        `${t("This user's account has already been synchronized with zarinpal.")} (${t("zarinpal id")}: ${zarinpalId})` :
                        t("This user's account is not synchronized with zarinpal.")
                      }
                    </div>
                    <LoaderButton
                      color='success'
                      loading={syncing}
                      disabled={syncing}
                      className="text-center"
                      onClick={this.zarinpalSync}
                      style={{minWidth: '100px'}}>
                      {!!zarinpalId ? t('Re-sync') : t('Sync')}
                    </LoaderButton>
                  </Row>
                  <Separator className="my-3"/>
                </div>
              }
              <FinalForm onSubmit={this.updateInfo}
               render={({handleSubmit, submitting}) => {
                 return (
                   <Form onSubmit={handleSubmit}>
                     <Row>
                       <Col><TextField item={textFields[0]}/></Col>
                       <Col><TextField item={textFields[1]}/></Col>
                     </Row>
                     <Rbac permission='update_user-kyc'>
                       <LoaderButton
                         loading={submitting}
                         onClick={handleSubmit}
                         disabled={submitting}
                         className="my-2 text-center"
                         style={{minWidth: '100px'}}>
                         {t('Save')}
                       </LoaderButton>
                     </Rbac>
                   </Form>
                 );
               }}
              />
              <Separator className="my-3"/>
              <Row>
                <Col>
                  <div className="mb-2">
                    <FinalForm
                      onSubmit={this.updatePhoneNumber}
                      initialValues={{phoneNumber: info.phoneNumber ? info.phoneNumber : undefined}}
                      render={({handleSubmit, submitting, pristine}) => {
                        return (
                          <Form onSubmit={handleSubmit}>
                            <div className="mt-2">
                              <div>
                               <span>
                                 {t('Phone Number')}
                                 <span className={info.phoneNumberVerified ? 'text-success' : 'text-danger'}>
                                   {info.phoneNumberVerified ? ` (${t('confirmed')})` : ` (${t('not confirmed')})`}
                                 </span>
                               </span>
                              </div>
                              <Field name="phoneNumber">
                                {({input}) => (
                                  <InputGroup>
                                    <Input
                                      {...input}
                                      placeholder={
                                        Rbac.hasPermission('update_user-phone-number') ?
                                          t('Enter user mobile number') : ''
                                      }
                                      valid={info.phoneNumberVerified}
                                    />
                                    <Rbac permission="update_user-phone-number">
                                      <InputGroupAddon addonType="append">
                                        <LoaderButton
                                          loading={submitting}
                                          onClick={handleSubmit}
                                          disabled={pristine || submitting}
                                        >
                                          {t('Save')}
                                        </LoaderButton>
                                      </InputGroupAddon>
                                    </Rbac>
                                    <FieldError name="phoneNumber"/>
                                  </InputGroup>
                                )}
                              </Field>
                            </div>
                          </Form>
                        );
                      }}
                    />
                  </div>
                  <div className="d-flex align-items-center">
                    <Switch
                      className="ltr"
                      disabled={!Rbac.hasPermission('update_user-kyc')}
                      onChange={this.onChangePhoneNumberStatus}
                      checked={info.phoneNumberVerified}
                      height={24}
                      width={45}
                    />
                    <span className="mx-1">{t('SMS Confirmation')}</span>
                  </div>
                </Col>
                <Col>
                  <div className="mb-2">
                    <span>{t('Kyc Status')}</span>
                    <Select
                      className="w-75"
                      styles={selectStyles}
                      options={this.statusOptions}
                      onChange={this.onChangeStatus}
                      isDisabled={!Rbac.hasPermission('update_user-kyc')}
                      value={{label: t(info.verificationStatus), value: info.verificationStatus}}
                      placeholder={t('Select')}
                    />
                  </div>
                  <div className="mb-3">
                    <span>{t('Identity Level')}</span>
                    <Select
                      className="w-75"
                      styles={selectStyles}
                      value={selectedLevel}
                      options={levelOptions}
                      onChange={automatedLevelEvaluation ? this.onChangeLevel : this.changeLevel}
                      isDisabled={!Rbac.hasPermission('update_user-kyc')}
                      placeholder={t('Select')}
                    />
                  </div>
                  <Rbac permission='view_profile'>
                    <div className='d-flex flex-row align-items-center mb-4'>
                      <div className="text-black-50">
                        {t('Automated Level Evaluation')}
                      </div>
                      {typeof automatedLevelEvaluation === 'boolean' ?
                        <Switch
                          className='mx-3 ltr'
                          disabled={!Rbac.hasPermission('update_user-settings')}
                          onChange={this.onChangeAutomatedLevelEvaluationStatus}
                          checked={automatedLevelEvaluation}
                          height={22}
                          width={45}
                        /> :
                        <Skeleton width={60} />
                      }
                    </div>
                  </Rbac>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(KycMetaInfo);
